(function (window, document) {
    'use strict';

    var state = {
        sheet: null,
        home: null,
        frame: null,
        closeButton: null,
        title: null,
        opener: null,
        activeRow: null,
        frameResizeObserver: null,
        mobileOpen: false,
        mobileScrollLock: null,
        mobileHistoryToken: null,
        focusedEmbeddedControl: null
    };
    var cancelledCheckout = null;
    var mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
    var mobileHistoryKey = 'iksonMusicLibraryLicensing';

    function isPrimaryActivation(event) {
        return !event.defaultPrevented
            && event.button === 0
            && !event.metaKey
            && !event.ctrlKey
            && !event.shiftKey
            && !event.altKey;
    }

    function lockCatalogueScroll() {
        var body = document.body;
        var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

        state.mobileScrollLock = {
            scrollY: scrollY,
            style: body.getAttribute('style')
        };
        body.style.cssText += ';position:fixed;top:' + (-scrollY) + 'px;right:0;left:0;width:100%;overflow:hidden;';
    }

    function unlockCatalogueScroll() {
        var lock = state.mobileScrollLock;
        var body = document.body;

        if (!lock) {
            return null;
        }

        if (lock.style === null) {
            body.removeAttribute('style');
        } else {
            body.setAttribute('style', lock.style);
        }
        state.mobileScrollLock = null;
        window.scrollTo(0, lock.scrollY);

        return lock.scrollY;
    }

    function keepFocusedControlVisible() {
        var control = state.focusedEmbeddedControl;
        var flow;
        var frameRect;
        var controlRect;
        var flowRect;
        var controlTop;
        var controlBottom;

        if (!state.mobileOpen || !control || !control.isConnected || !state.frame) {
            return;
        }

        flow = state.sheet.querySelector('.music-library-license-sheet__flow');
        if (!flow) {
            return;
        }

        frameRect = state.frame.getBoundingClientRect();
        controlRect = control.getBoundingClientRect();
        flowRect = flow.getBoundingClientRect();
        controlTop = frameRect.top + controlRect.top;
        controlBottom = frameRect.top + controlRect.bottom;

        if (controlBottom > flowRect.bottom - 20) {
            flow.scrollTop += controlBottom - flowRect.bottom + 20;
        } else if (controlTop < flowRect.top + 16) {
            flow.scrollTop -= flowRect.top + 16 - controlTop;
        }
    }

    function syncMobileViewport() {
        var viewport;
        var viewportTop;
        var viewportHeight;
        var player;
        var playerRect;

        if (!state.mobileOpen || !state.sheet || state.sheet.hidden) {
            return;
        }

        viewport = window.visualViewport;
        viewportTop = viewport ? viewport.offsetTop : 0;
        viewportHeight = viewport ? viewport.height : window.innerHeight;
        player = document.getElementById('waveform-player');

        if (player && player.getAttribute('aria-hidden') !== 'true') {
            playerRect = player.getBoundingClientRect();
            if (playerRect.top < viewportTop + viewportHeight && playerRect.bottom > viewportTop) {
                viewportHeight = Math.max(1, Math.min(viewportHeight, playerRect.top - viewportTop));
            }
        }

        state.sheet.style.setProperty('--music-library-license-viewport-top', Math.max(0, viewportTop) + 'px');
        state.sheet.style.setProperty('--music-library-license-viewport-height', Math.max(1, viewportHeight) + 'px');
        window.requestAnimationFrame(keepFocusedControlVisible);
    }

    function removeMobileHistoryMarker() {
        var current = window.history.state;
        var next;

        if (!state.mobileHistoryToken
            || !current
            || current[mobileHistoryKey] !== state.mobileHistoryToken) {
            return;
        }

        next = Object.assign({}, current);
        delete next[mobileHistoryKey];
        window.history.replaceState(next, '', window.location.href);
    }

    function enterMobilePresentation() {
        var nextHistoryState;

        if (state.mobileOpen) {
            syncMobileViewport();
            return;
        }

        state.mobileOpen = true;
        document.body.classList.add('music-library-licensing-mobile-open');
        lockCatalogueScroll();
        if (!state.mobileHistoryToken) {
            state.mobileHistoryToken = String(Date.now()) + ':' + String(Math.random()).slice(2);
            nextHistoryState = Object.assign({}, window.history.state || {});
            nextHistoryState[mobileHistoryKey] = state.mobileHistoryToken;
            window.history.pushState(nextHistoryState, '', window.location.href);
        }
        syncMobileViewport();
    }

    function leaveMobilePresentation(preserveHistory) {
        var restoredScrollY;

        if (!state.mobileOpen) {
            if (!preserveHistory) {
                removeMobileHistoryMarker();
                state.mobileHistoryToken = null;
            }
            return null;
        }

        if (!preserveHistory) {
            removeMobileHistoryMarker();
        }
        state.mobileOpen = false;
        state.focusedEmbeddedControl = null;
        document.body.classList.remove('music-library-licensing-mobile-open');
        state.sheet.style.removeProperty('--music-library-license-viewport-top');
        state.sheet.style.removeProperty('--music-library-license-viewport-height');
        restoredScrollY = unlockCatalogueScroll();
        if (!preserveHistory) {
            state.mobileHistoryToken = null;
        }

        return restoredScrollY;
    }

    function disconnectFrameObserver() {
        if (!state.frameResizeObserver) {
            return;
        }

        state.frameResizeObserver.disconnect();
        state.frameResizeObserver = null;
    }

    function rehomeSheet() {
        if (!state.sheet
            || !state.home
            || !state.home.isConnected
            || state.sheet.parentNode === state.home) {
            return;
        }

        state.home.appendChild(state.sheet);
    }

    function resetActiveTrack() {
        if (state.activeRow) {
            state.activeRow.classList.remove('is-licensing-track');
        }

        if (state.opener) {
            state.opener.setAttribute('aria-expanded', 'false');
            state.opener.textContent = state.opener.getAttribute('data-license-original-label') || 'Use / License';
        }
    }

    function resetStateFor(sheet) {
        if (state.sheet === sheet) {
            return true;
        }

        if (state.mobileOpen) {
            closeSheet(false);
        }
        disconnectFrameObserver();
        state = {
            sheet: sheet,
            home: sheet.closest('[data-music-library-license-home]'),
            frame: sheet.querySelector('[data-music-library-license-frame]'),
            closeButton: sheet.querySelector('[data-music-library-license-close]'),
            title: sheet.querySelector('[data-music-library-license-title]'),
            opener: null,
            activeRow: null,
            frameResizeObserver: null,
            mobileOpen: false,
            mobileScrollLock: null,
            mobileHistoryToken: null,
            focusedEmbeddedControl: null
        };

        if (!state.home || !state.frame || !state.closeButton || !state.title) {
            return false;
        }

        state.frame.addEventListener('load', function () {
            prepareEmbeddedPage(sheet);
        });

        return true;
    }

    function prepareCurrentSheet() {
        var sheet = document.querySelector('[data-music-library-license-sheet]');

        return sheet ? resetStateFor(sheet) : false;
    }

    function resizeFrame() {
        var embeddedDocument;
        var shell;

        if (!state.sheet || state.sheet.hidden || !state.frame) {
            return;
        }

        try {
            embeddedDocument = state.frame.contentDocument;
            shell = embeddedDocument && embeddedDocument.querySelector('.licensing-shell');
        } catch (error) {
            return;
        }

        if (!shell) {
            return;
        }

        state.frame.style.height = Math.ceil(Math.max(shell.scrollHeight, shell.offsetHeight)) + 'px';
    }

    function prepareEmbeddedPage(expectedSheet) {
        var embeddedDocument;
        var embeddedWindow;
        var embeddedBody;
        var shell;
        var checkoutForm;
        var checkoutAction;
        var nextHistoryState;

        if (state.sheet !== expectedSheet || expectedSheet.hidden || !state.frame) {
            return;
        }

        try {
            embeddedDocument = state.frame.contentDocument;
            embeddedWindow = state.frame.contentWindow;
            embeddedBody = embeddedDocument && embeddedDocument.body;
            shell = embeddedDocument && embeddedDocument.querySelector('.licensing-shell');
        } catch (error) {
            return;
        }

        if (!embeddedDocument || !embeddedWindow || !embeddedBody || !shell) {
            return;
        }

        embeddedBody.classList.add('music-library-licensing-inline-frame');
        checkoutForm = embeddedDocument.querySelector('.licensing-checkout-form');
        if (checkoutForm && window.location.pathname === '/music') {
            try {
                checkoutAction = new window.URL(checkoutForm.action, embeddedWindow.location.href);
                checkoutAction.searchParams.set('return_to_music', window.location.pathname + window.location.search + window.location.hash);
                checkoutForm.action = checkoutAction.href;
            } catch (error) {
                // Keep the existing standalone Review cancellation fallback.
            }
        }
        embeddedDocument.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                requestClose(true);
            }
        });
        embeddedDocument.addEventListener('focusin', function (event) {
            state.focusedEmbeddedControl = event.target;
            syncMobileViewport();
        });
        embeddedWindow.addEventListener('popstate', function () {
            if (state.mobileOpen) {
                closeSheet(true);
            }
        });

        window.requestAnimationFrame(resizeFrame);
        disconnectFrameObserver();

        if (embeddedWindow.ResizeObserver) {
            state.frameResizeObserver = new embeddedWindow.ResizeObserver(resizeFrame);
            state.frameResizeObserver.observe(shell);
        }
        if (state.mobileOpen && state.mobileHistoryToken) {
            nextHistoryState = Object.assign({}, window.history.state || {});
            nextHistoryState[mobileHistoryKey] = state.mobileHistoryToken;
            window.history.pushState(nextHistoryState, '', window.location.href);
        }
    }

    function closeSheet(restoreFocus) {
        var wasOpen;
        var opener;
        var restoredScrollY;

        if (!state.sheet) {
            return;
        }

        wasOpen = !state.sheet.hidden;
        opener = state.opener;
        restoredScrollY = leaveMobilePresentation();
        state.sheet.hidden = true;
        disconnectFrameObserver();
        resetActiveTrack();

        if (state.frame) {
            state.frame.src = 'about:blank';
            state.frame.style.height = '';
        }

        rehomeSheet();
        state.opener = null;
        state.activeRow = null;

        if (wasOpen && restoreFocus !== false && opener && opener.isConnected) {
            try {
                opener.focus({ preventScroll: true });
            } catch (error) {
                opener.focus();
            }
        }
        if (restoredScrollY !== null) {
            window.scrollTo(0, restoredScrollY);
        }
    }

    function requestClose(restoreFocus) {
        var current = window.history.state;

        if (state.mobileOpen
            && state.mobileHistoryToken
            && current
            && current[mobileHistoryKey] === state.mobileHistoryToken) {
            window.history.back();
            return;
        }

        closeSheet(restoreFocus);
    }

    function syncResponsivePresentation() {
        if (!state.sheet || state.sheet.hidden || !state.activeRow) {
            return;
        }

        if (mobileMedia.matches) {
            enterMobilePresentation();
        } else {
            leaveMobilePresentation(true);
        }
    }

    function openSheet(trigger, destinationOverride) {
        var destination;
        var destinationValue;
        var row;
        var rowTitle;

        if (!prepareCurrentSheet()) {
            return false;
        }

        try {
            destinationValue = destinationOverride
                || trigger.getAttribute('data-music-library-license-embed-url')
                || '';
            destination = new window.URL(destinationValue, window.location.href);
        } catch (error) {
            return false;
        }

        if (!destinationValue || destination.origin !== window.location.origin) {
            return false;
        }

        row = trigger.closest('[data-music-library-track-row]');

        if (!row || !row.parentNode || !state.home || !state.home.isConnected) {
            return false;
        }

        if (!state.sheet.hidden && state.opener === trigger) {
            requestClose(true);
            return true;
        }

        if (!state.sheet.hidden) {
            closeSheet(false);
        }

        rowTitle = row.querySelector('.music-library-audition-row__identity h4');
        row.parentNode.insertBefore(state.sheet, row.nextSibling);
        state.title.textContent = 'Use or license ' + (rowTitle ? rowTitle.textContent.trim() : 'selected Track');
        state.opener = trigger;
        state.activeRow = row;
        trigger.setAttribute('data-license-original-label', trigger.textContent.trim());
        trigger.setAttribute('aria-expanded', 'true');
        trigger.textContent = 'Close';
        row.classList.add('is-licensing-track');
        state.sheet.hidden = false;
        if (mobileMedia.matches) {
            enterMobilePresentation();
        }
        state.frame.style.height = '340px';
        state.frame.src = destination.href;
        state.closeButton.focus();

        return true;
    }

    function triggerForTrack(trackRelease) {
        var triggers = document.querySelectorAll('[data-music-library-license-intent]');
        var destination;
        var index;

        for (index = 0; index < triggers.length; index += 1) {
            try {
                destination = new window.URL(triggers[index].getAttribute('data-music-library-license-embed-url'), window.location.href);
                if (destination.searchParams.get('track') === trackRelease) {
                    return triggers[index];
                }
            } catch (error) {
                // Ignore malformed fallback links and continue looking.
            }
        }

        return null;
    }

    function cancelledReviewUrl(embedded) {
        return '/licensing/podcast/review/' + encodeURIComponent(cancelledCheckout.orderUuid)
            + (embedded ? '?embedded=1&cancelled=1' : '?cancelled=1');
    }

    function continueCancelledCheckout() {
        var trigger = triggerForTrack(cancelledCheckout.trackRelease);
        var loadMore;

        if (trigger && openSheet(trigger, cancelledReviewUrl(true))) {
            cancelledCheckout.params.delete('licensing_order');
            cancelledCheckout.params.delete('licensing_track');
            cancelledCheckout.params.delete('licensing_cancelled');
            window.history.replaceState(window.history.state, '', window.location.pathname
                + (cancelledCheckout.params.toString() ? '?' + cancelledCheckout.params.toString() : '')
                + window.location.hash);
            cancelledCheckout = null;
            return;
        }

        loadMore = document.querySelector('[data-music-library-load-more-link]:not([aria-disabled="true"])');
        if (loadMore) {
            loadMore.click();
            return;
        }

        window.location.replace(cancelledReviewUrl(false));
    }

    function restoreCancelledCheckout() {
        var params;
        var orderUuid;
        var trackRelease;

        if (window.location.pathname !== '/music'
            || !window.URLSearchParams
            || !document.querySelector('[data-music-library-license-sheet]')) {
            return;
        }

        params = new window.URLSearchParams(window.location.search);
        orderUuid = params.get('licensing_order') || '';
        trackRelease = params.get('licensing_track') || '';
        if (params.get('licensing_cancelled') !== '1'
            || !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(orderUuid)
            || !/^\d+$/.test(trackRelease)) {
            return;
        }

        cancelledCheckout = {
            orderUuid: orderUuid,
            trackRelease: trackRelease,
            params: params
        };
        continueCancelledCheckout();
    }

    document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-music-library-license-intent]');
        var closeButton;
        var sheet;

        if (trigger && isPrimaryActivation(event) && openSheet(trigger)) {
            event.preventDefault();
            return;
        }

        closeButton = event.target.closest('[data-music-library-license-close]');
        sheet = closeButton && closeButton.closest('[data-music-library-license-sheet]');

        if (closeButton && sheet && resetStateFor(sheet)) {
            event.preventDefault();
            requestClose(true);
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && state.sheet && !state.sheet.hidden) {
            requestClose(true);
        }
    });

    window.addEventListener('popstate', function (event) {
        if (state.mobileOpen) {
            event.stopImmediatePropagation();
            closeSheet(true);
        }
    });

    document.addEventListener('ikson:music-library-tracks-updated', function () {
        closeSheet(false);
        if (cancelledCheckout) {
            window.setTimeout(continueCancelledCheckout, 0);
        }
    });

    window.addEventListener('resize', function () {
        syncResponsivePresentation();
        syncMobileViewport();
        resizeFrame();
    });
    if (typeof mobileMedia.addEventListener === 'function') {
        mobileMedia.addEventListener('change', syncResponsivePresentation);
    } else if (typeof mobileMedia.addListener === 'function') {
        mobileMedia.addListener(syncResponsivePresentation);
    }
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', syncMobileViewport);
        window.visualViewport.addEventListener('scroll', syncMobileViewport);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', restoreCancelledCheckout, { once: true });
    } else {
        window.setTimeout(restoreCancelledCheckout, 0);
    }
}(window, document));
